/**
 * Notification history API for the in-app notification panel.
 */

import { apiService } from './api';

export interface NotificationHistoryItem {
  id: string;
  userId: string;
  type: string;
  title: string;
  body: string;
  read: boolean;
  readAt: string | null;
  data?: { url?: string; entityId?: string; entityType?: string };
  createdAt: string;
}

export interface NotificationsListResponse {
  items: NotificationHistoryItem[];
  total: number;
}

export interface UnreadCountResponse {
  count: number;
}

const BASE = '/notifications';

const emptyListResponse: NotificationsListResponse = { items: [], total: 0 };

export const notificationService = {
  list(params?: { limit?: number; offset?: number; unreadOnly?: boolean }) {
    return apiService
      .get<NotificationsListResponse>(BASE, { params })
      .then((r) => r.data)
      .catch(() => emptyListResponse);
  },

  getUnreadCount() {
    return apiService.get<UnreadCountResponse>(`${BASE}/unread-count`).then((r) => r.data.count);
  },

  markRead(id: string) {
    return apiService.patch(`${BASE}/${id}/read`).then((r) => r.data);
  },

  markAllRead() {
    return apiService.patch(`${BASE}/read-all`).then((r) => r.data);
  },
};
